<template>
  <div style="border: 0px solid red; height:100%">
    <el-container style="padding: 0px; width: 100%;height:100%;margin-top:25%">
      <el-main style="padding: 100px 0px 10px 0px; width: 100%;height: 100%;">
        <div align='center'>
          <!-- 初期トレーニングボタン -->
          <div style='padding:0px 0px 15px 0px;'>
            <el-button class="i0014-button1 css-btn" @click.native="button1_Click" type="primary" v-html="$t('MODULE.I0014_LBL_BTN1')"></el-button>
          </div>
          <!-- コンプライアンスボタン -->
          <div style='padding:0px 0px 15px 0px;'>
            <el-button class="i0014-button1 css-btn" @click.native="button2_Click" type="primary" v-html="$t('MODULE.I0014_LBL_BTN2')"></el-button>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>

let url = require('@/../config/sysConfig')

export default {
  data() {
    return {
      userInfo: [],
    };
  },
  methods: {
    //初期トレーニング方法処理
    button1_Click() {
      window.open(url.routerUrl_I0014_btn1URL)
    },
    //コンプライアンス方法処理
    button2_Click() {
      window.open(url.routerUrl_I0014_btn2URL)
    },
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('userInfo'))
  },
};
</script>
<style scope>
/* 初期トレーニング方法ボタン */
/* コンプライアンスボタン */
.i0014-button1 {
  width: 65%;
  height: 60px;
  padding: 0px;
  background-image: linear-gradient(0deg, #3cc6fa, #23b2e8);
  font-size: 10pt;
}
/*导航*/
.home-content-menu_i0014 {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
}
/*面包屑*/
.el-crumb_i0014 {
  background-image: linear-gradient(#5c5d5d, #717171);
  padding-left: 5px;
  padding-top: 4px;
  height: 20px;
}
</style>


// WEBPACK FOOTER //
// src/module/page/i_0014.vue